import 'xdlocalstorage'
import { mutationNames } from '@/store/storeKey'
import api from '@/modules/api'
import moment from 'moment'
import * as storage from '@/modules/storage'

const state = {
  user: storage.user.get() || {
    'Address': '',
    'City': '',
    'CompanyName': '',
    'ContactFirstname': '',
    'ContactLastname': '',
    'Country': '',
    'Currency': '',
    'Fax': '',
    'Username': '',
    'Id': 0,
    'Language': '',
    'Email': '',
    'Phone': '',
    'PostalCode': '',
    'PublishingCredits': 0,
    'Region': '',
    'UserLevel': 0,
    'VATId': '',
    'Token': '',
    'AppAdministrationLevel': 0,
    'EditAppStructureLevel': 0,
    'ContentManagementLevel': 0,
    'AppDesignLevel': 0,
    'PublishingLevel': 0,
    'PushNotificationLevel': 0,
    'IncomingMessagesLevel': 0,
    'AppAnalyticsLevel': 0,
    'InvitingUsersLevel': 0,
    'AccountBillingAddressLevel': 0,
    'AccountAppEditingHistoryLevel': 0,
    'AdvancedDesignSettingsApplied': false,
    'Authenticated': false,
    'CoachmarksCompletedTemplateSelection': false,
    'CoachmarksCompletedDesignSection ': false,
    'CoachmarksCompletedContentSection ': false,
    'ActivePin': '',
    'AppName': ''
  },
  ActiveUserPIN: '',
  ActiveUserPINMessage: '',
  showUserRegistration: true,
  showVerificationPin: false
}
const getters = {
  user: state => state.user,
  IsAuthenticated: state => state.user.Authenticated,
  ShortDateFormat: state => state.user.ShortDateFormat,
  ActiveUserPIN: state => state.ActiveUserPIN,
  ActiveUserPINMessage: state => state.ActiveUserPINMessage,
  showVerificationPin: state => state.showVerificationPin,
  showUserRegistration: state => state.showUserRegistration
}
const mutations = {
  [mutationNames.SET_USER] (state, user) {
    state.user = user
  },
  [mutationNames.SET_ACTIVEPIN] (state, data) {
    state.ActiveUserPIN = data.code
    state.ActiveUserPINMessage = data.message
  },
  [mutationNames.SET_VERIFICATIONPIN] (state, showVal) {
    state.showVerificationPin = showVal
  },
  [mutationNames.SET_USERREGISTRATION] (state, showVal) {
    state.showUserRegistration = showVal
  },
  updateUserEmail (state, email) {
    state.user.Email = email
  },
  updateUserAppName (state, email) {
    state.user.AppName = email
  },
  updateUserActivePin (state, pin) {
    state.user.CoachmarksCompletedTemplateSelection = true
    state.user.ActivePin = pin
  },
  updateCheckoutVendorClientiId (state, CheckoutVendorClientiId) {
    state.user.CheckoutVendorClientiId = CheckoutVendorClientiId
  },
  updateUser (state, payload) {
    Object.assign(state.user, payload)
  }
}

const actions = {
  setUser ({ commit }, user) {
    storage.user.set(user)
    commit(mutationNames.SET_USER, user)
  },
  setUserEmail ({ commit }, email) {
    commit('updateUserEmail', email)
    storage.user.set(state.user)
  },
  setUserApp ({ commit }, appName) {
    commit('updateUserAppName', appName)
    storage.user.set(state.user)
  },
  setUserActivePin ({ commit }, apin) {
    commit('updateUserActivePin', apin)
    storage.user.set(state.user)
  },
  setCheckoutVendorClientiId ({ commit }, CheckoutVendorClientiId) {
    commit('updateCheckoutVendorClientiId', CheckoutVendorClientiId)
    storage.user.set(state.user)
  },
  async signIn ({ commit, dispatch, rootGetters }, payload) {
    payload.CurrentLocale = payload.CurrentLocale || rootGetters.locale
    payload.CurrentLocale = payload.CurrentLocale === 'de' ? 'de-De' : payload.CurrentLocale
    try {
      const response = await api.user.signIn(payload)
      return dispatch('saveToken', { Token: response.Message, Username: payload.UserName })
    } catch (err) {
      if (err.json) {
        let res = false
        try {
          res = await dispatch('signInOldSystem', payload)
        } catch (e) {
          console.log(e)
          res = false
        }
        if (!res) {
          // const error = await err.json()
          console.log('error.Message')
          throw new Error('your account is not valid')
        }
      } else {
        console.log('error.Message')
        throw new Error('your account is not valid')
        // throw err
      }
    }
  },
  async saveToken ({ commit, dispatch, state, rootGetters }, clientToken) {
    const user = await api.user.saveToken(clientToken)
    user.Authenticated = true
    const IsUserPurchasedProduct = true // await api.Order.IsUserPurchasedProduct(user.Id)
    let day = moment().diff(moment(user.RegistrationDate), 'days')
    user.IsUserPurchasedProduct = IsUserPurchasedProduct
    user.days = day < 30 ? 30 - day : day === 30 ? 30 : day
    dispatch('setUser', user)
    return user
  },
  async orderSignIn ({ commit, dispatch, rootGetters }, payload) {
    payload.CurrentLocale = payload.CurrentLocale || rootGetters.language
    const response = await api.user.orderSignIn(payload)
    const message = response.Message
    return dispatch('orderSaveToken', {
      Token: message,
      Username: payload.UserName,
      Subscription_Id: payload.Subscription_Id
    })
  },
  async orderSaveToken ({ commit, dispatch }, clientToken) {
    const user = await api.user.saveToken(clientToken)
    user.Authenticated = true
    dispatch('setUser', user)
    dispatch('populateApps')
    if (clientToken.Subscription_Id !== null) {
      dispatch('setActiveSubscriptionId')
    }
    dispatch('populateOrderServiceData')
    return user
  },
  logOut ({ commit }, payload) {
    commit('updateUser', payload)
  },
  async signInOldSystem ({ commit }, payload) {
    const oldSystemResponse = await api.oldSystem.signIn(payload)
    const message = oldSystemResponse.Message
    if (message.indexOf('<br>') !== -1) {
      const res = message.split('<br>')
      if (res[0] === '200') {
        const ClientToken = {}
        ClientToken.Token = res[1]
        ClientToken.Username = payload.UserName
        const saveTokenResponse = await api.oldSystem.saveToken(ClientToken)
        const client = JSON.parse(saveTokenResponse)
        const activityLog = {
          Client_Id: client[0].Id,
          LogDate: new Date(),
          LogMessage_Id: 1,
          Username: payload.UserName
        }
        await api.oldSystem.saveActivityLog(activityLog)
        const oldDesignerBaseURL = 'https://designer.onair-appbuilder.com/'
        window.xdLocalStorage.init({
          iframeUrl: oldDesignerBaseURL + 'Account',
          initCallback () {
            window.xdLocalStorage.setItem('Clients_old', saveTokenResponse, (data) => {
              window.xdLocalStorage.setItem('lan', client[0].Language.toLowerCase(), () => {})
              window.xdLocalStorage.setItem('PageLocation_old', 2, (data) => {
                setTimeout(() => {
                  window.location = oldDesignerBaseURL + 'Dashboard'
                }, 10)
              })
            })
          }
        })
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  async sendActivePinMail ({ commit }, payload) {
    const data = await api.user.generateActivePIN(payload)
    commit(mutationNames.SET_ACTIVEPIN, data)
    return data
  },
  async verifyActivePinMail ({ commit }, payload) {
    const result = await api.user.VerifyActivePinCode(payload)
    return result
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js